export enum InvoiceType {
	incoming = "incoming",
	outgoing = "outgoing",
	general = "general",
}
